import { render, staticRenderFns } from "./AddressSelect.vue?vue&type=template&id=74aa89da&scoped=true&"
import script from "./AddressSelect.vue?vue&type=script&lang=js&"
export * from "./AddressSelect.vue?vue&type=script&lang=js&"
import style0 from "./AddressSelect.vue?vue&type=style&index=0&id=74aa89da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74aa89da",
  null
  
)

export default component.exports